import api from 'containers/api'
import useDataLoader from 'containers/dataLoader'

import { selectToken } from 'containers/authentication/authenticationSlice'
import { useSelector } from 'react-redux'

import { IOrganization } from 'types'

const useGetFeatures = (org: IOrganization) => {
  const token = useSelector(selectToken)

  const getFeatures = async (organizationId?: number) => {
    const orgId = organizationId || org?.id
    if (!orgId) {
      return null
    }
    const res = await api.getFeatures(token, orgId)
    return res
  }

  return useDataLoader(getFeatures)
}

export default useGetFeatures
